import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useRef, useState } from "react"
import List from "../../../components/List/List"
import { categoryMemory } from "../../../Objects/Memory/Memory"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useGetCategory } from "../../../hooks/Category/useGetCategory"
import { CategoryEntity } from "../../../Objects/Category/CategoryEntity"
import { CategoryPupop } from "./CategoryPupop"
import { useTranslation } from "react-i18next"
import { useLocation, useSearchParams } from "react-router-dom"
import { CategoryOrderPopup } from "./CategoryOrderPopup"
import { faInbox } from "@fortawesome/free-solid-svg-icons"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const CategoryPage: React.FC = () => {
  const { t } = useTranslation("category")

  const [searchParams] = useSearchParams()

  const location = useLocation()

  const lastQuickCategoryOrderKeyRef = useRef("")

  const [enable, setEnable] = useState(
    searchParams.get("enableCreate") === "true" || searchParams.get("onboardingCreate") === "true",
  )

  const { handleGetCategory } = useGetCategory()

  const [category, setCategory] = useState<CategoryEntity | undefined>(undefined)

  const [enableImport, setEnableImport] = useState(false)

  const [enableOrderPopup, setEnableOrderPopup] = useState(false)

  useEffect(() => {
    handleGetCategory(() => {})
  }, [])

  const handleOpenEdite = (id: number) => {
    const entity = categoryMemory.findById(id)!

    handleSwitchEditeOrAdd(true)

    setCategory(entity)
  }

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setCategory(undefined)

    setEnable(status)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  useEffect(() => {
    if (searchParams.get("quickAction") !== "category-order") {
      return
    }

    const openKey = `${location.key}:${location.search}`

    if (lastQuickCategoryOrderKeyRef.current === openKey) {
      return
    }

    lastQuickCategoryOrderKeyRef.current = openKey

    setEnableOrderPopup(true)
  }, [location.key, location.search, searchParams])

  const handleCopyCategory = () => {
    if (!category) {
      return
    }

    setCategory(new CategoryEntity({ ...category, id: -1, isDefault: false }))
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          messageCount={t("list:label_category_page_message_count")}
          messageEmpty={t("list:label_category_page_message_empty")}
          nameFindSearch={t("list:label_category_page_place_holder")}
          data={categoryMemory.getListCards(true)}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleRefreshButton={() => handleGetCategory(() => {})}
          handleOnClick={(e) => handleOpenEdite(e)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleExtraFloatButton={() => setEnableOrderPopup(true)}
          extraFloatButtonDescriptionKey="interactionDescriptions:pages.products.category.categoryPage.button.openManualOrder"
          extraFloatButtonColor="#FFB45C"
          extraFloatButtonIcon={faInbox}
        />
      </div>

      {enable && (
        <CategoryPupop
          category={category}
          title={category && category.id !== -1 ? t("title_popup_edite") : t("title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
          onCopy={handleCopyCategory}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="categorias"
          title={t("dataImport:title", { target: t("dataImport:target_categories") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetCategory(() => {})}
        />
      )}

      {enableOrderPopup && (
        <CategoryOrderPopup
          categories={categoryMemory.listData}
          onClose={() => setEnableOrderPopup(false)}
          onSaved={() => handleGetCategory(() => {})}
        />
      )}
    </>
  )
}
